import styled from "styled-components";
import colors from '../../assets/styles/colors';

export const ClientProspectingContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 44px 20px 15px 20px;
    background: ${colors.bgGray};
`

export const ClientProspectingContent = styled.div``

export const ClientProspectingHeader = styled.div``

export const ClientProspectingData = styled.div`
    width: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
`
